import {mountHtmlIslands} from 'lib/htmlIsland/mountHtmlIslands';

// Hydrates a surface's TDS2 HTML islands once the DOM is ready. `islands` maps
// each custom-element tag to its serializable config (e.g. className); `bindings`
// maps the same tags to the JS half (React component + parse adapter). Merging
// the two per tag is all a surface pack does, so this stays surface-agnostic and
// every pack is a thin static-import shim over it (see packs/unitComponents.js).
export function hydrate(islands, bindings) {
  const mount = () =>
    Object.entries(islands).forEach(([tag, config]) =>
      mountHtmlIslands({tag, ...config, ...bindings[tag]}));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
}
